import React from 'react';
import type { ConsultantType } from '../../types/businessConsultant';

interface ConversationStartersProps {
  consultantType: ConsultantType;
  onSelectPrompt: (prompt: string) => void;
  dynamicStarters?: string[]; // Optional data-driven starters
}

const CONVERSATION_STARTERS: Record<ConsultantType, string[]> = {
  marketing: [
    "Show me my SEO performance and what I should improve",
    "Help me create a content calendar for next month",
    "What are the best channels to reach my target audience?",
    "Analyze my recent marketing campaigns",
    "Create a launch plan for a new product"
  ],
  finance: [
    "Show me my CRM pipeline and revenue forecast",
    "What deals need my attention right now?",
    "Help me forecast cash flow for next quarter",
    "Analyze my unit economics and profitability",
    "What financial metrics should I track monthly?"
  ],
  strategy: [
    "Give me a business summary of what needs my attention",
    "Show me my project deadlines and overdue tasks",
    "Create a 90-day growth plan with milestones",
    "Help me prioritize my projects and tasks",
    "Analyze risks and create mitigation plans"
  ]
};

const ConversationStarters: React.FC<ConversationStartersProps> = ({
  consultantType,
  onSelectPrompt,
  dynamicStarters
}) => {
  // Use dynamic starters if provided, otherwise fall back to static ones
  const starters = dynamicStarters && dynamicStarters.length > 0
    ? dynamicStarters
    : CONVERSATION_STARTERS[consultantType] || [];

  return (
    <div className="conversation-starters p-6 bg-gradient-to-br from-blue-50 to-purple-50 rounded-lg border border-blue-100">
      <div className="flex items-center gap-2 mb-4">
        <span className="text-2xl">💡</span>
        <h3 className="text-sm font-semibold text-gray-900">Try asking me about:</h3>
      </div>
      <div className="grid gap-2">
        {starters.map((prompt, idx) => (
          <button
            key={idx}
            onClick={() => onSelectPrompt(prompt)}
            className="text-left px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm text-gray-700 hover:bg-blue-50 hover:border-blue-300 hover:text-blue-700 transition-all shadow-sm hover:shadow"
          >
            {prompt}
          </button>
        ))}
      </div>
      <p className="text-xs text-gray-500 mt-4 text-center">
        Or just type your question naturally - I'm here to help! 🚀
      </p>
    </div>
  );
};

export default ConversationStarters;
